import { Client } from '../../../clients/interfaces/client.interface';
import { ClientTask } from '../../model/client-task.model';
import { ClientTaskAnswer } from '../../model/client-task-answer.model';
import { ClientTaskResult } from '../../model/client-task-result.model';
import { ConfigServiceProvider } from '../../../core/services/config-service/config-service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Page } from '../../../core/model/page.model';
import { SellionsEvent } from '../../../calendar/services/events-service/events-service';
import { tap } from 'rxjs/operators';
import { tasks } from '../../../../assets/tasks/tasks';

@Injectable()
export class VisitTasksService {
  constructor(
    private http: HttpClient,
    private configService: ConfigServiceProvider,
  ) {}

  getTasks(): Observable<ClientTask[]> {
    return new Observable<ClientTask[]>((observer) => {
      observer.next(tasks);
      observer.complete();
    });
  }

  endVisit(
    event: SellionsEvent,
    taskResults: ClientTaskAnswer[],
  ): Observable<void> {
    let urlParams = new HttpParams();
    urlParams = urlParams.set('eventId', event.eventId.toString());
    return this.http
      .post<void>(this.configService.getUrl('visitTaskEnd'), taskResults, {
        params: urlParams,
      })
      .pipe(tap(() => event.status === 'COMPLETED'));
  }

  getDoneTasksForClient(
    client: Client,
    page: number = 0,
  ): Observable<Page<ClientTaskResult>> {
    let urlParams = new HttpParams();
    urlParams = urlParams.set('clientId', client.id.toString());
    urlParams = urlParams.set('page', page.toString());
    return this.http.get<Page<ClientTaskResult>>(
      this.configService.getUrl('visitTaskDone'),
      { params: urlParams },
    );
  }

  getDoneTaskForEvent(
    event: SellionsEvent,
  ): Observable<Page<ClientTaskResult>> {
    let urlParams = new HttpParams();
    urlParams = urlParams.set('eventId', event.eventId.toString());
    return this.http.get<Page<ClientTaskResult>>(
      this.configService.getUrl('visitTaskDone'),
      { params: urlParams },
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/engine/services/tasks/tasks.service.ts